module.exports = __webpack_public_path__ + "static/media/Freedom Boat Club Logo.068d33a4.png";